export const formatFromMilliseconds = (milliseconds: number): string => {
  if (milliseconds < 1000) {
    return '00:00:00';
  }

  const totalSeconds = Math.floor(milliseconds / 1000);
  const formattedHours = Math.floor(totalSeconds / 3600);
  const remainingSeconds = totalSeconds % 3600;
  const formattedMinutes = Math.floor(remainingSeconds / 60);
  const formattedSeconds = remainingSeconds % 60;

  return `${formattedHours}:${String(formattedMinutes).padStart(2, '0')}:${String(formattedSeconds).padStart(2, '0')}`;
};
